import script from "./affect.vue?vue&type=script&setup=true&lang=js"
export * from "./affect.vue?vue&type=script&setup=true&lang=js"

import "./affect.vue?vue&type=style&index=0&id=72fbf6dd&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fbf6dd"]])

export default __exports__